import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faChevronDown,
  faCalendarAlt,
  faUmbrellaBeach,
  faGraduationCap,
  faHome,
  faArrowTrendUp,
  faChartLine
} from '@fortawesome/free-solid-svg-icons';

const CoinsPortfolio = () => {
  const [selectedTimeframe, setSelectedTimeframe] = useState('1M');

  const portfolioData = {
    totalValue: 96845.21,
    invested: 88934.12,
    return: 7911.05,
    returnPercentage: 8.89,
    graphData: [89906, 92384, 94862], // Y-axis values
    funds: [
      {
        id: 1,
        name: "Bitcoin",
        status: "ON TRACK",
        statusColor: "#10B981",
        currentValue: 48422.59,
        gain: 3955.53,
        gainPercentage: 8.91,
        progress: 75,
        icon: faUmbrellaBeach,
        iconColor: "#3B82F6"
      },
      {
        id: 2,
        name: "Ethereum",
        status: "AHEAD",
        statusColor: "#10B981",
        currentValue: 29053.55,
        gain: 2373.32,
        gainPercentage: 8.87,
        progress: 65,
        icon: faGraduationCap,
        iconColor: "#8B5CF6"
      },
      {
        id: 3,
        name: "Litecoin",
        status: "BEHIND",
        statusColor: "#F59E0B",
        currentValue: 16204.61,
        gain: -1582.21,
        gainPercentage: -8.90,
        progress: 45,
        icon: faHome,
        iconColor: "#EF4444"
      }
    ]
  };

  return (
    <div className="portfolio-card-modern rounded-4 shadow-sm p-4 mb-4"
      style={{
        background: "linear-gradient(90deg, #18181b 0%, #23272f85 100%)",
        border: "1px solid #23272f",
        color: "#fff",
      }}>
      
      {/* Header */}
      <div className="row align-items-center justify-content-between mb-4 g-3">
        <div className="col-md-auto">
          <h6 className="fw-semibold mb-1 text-white">Portfolio</h6>
          <small className="text-secondary">
            Track your investments and financial goals
          </small>
        </div>
      </div>

      {/* Main Content */}
      <div className="row align-items-center">
        {/* Left Side - Portfolio Summary */}
        <div className="col-md-4">
          <div className="d-flex align-items-start flex-wrap">
            <div>
              <div className="text-secondary small mb-1 d-flex align-items-center">
                <div
                  className="balance-icon d-flex align-items-center justify-content-center rounded-circle me-3"
                  style={{
                    background: "linear-gradient(135deg, #f80 0%, #ffcf99 100%)",
                    width: "30px",
                    height: "30px",
                    boxShadow: "0 2px 8px 0 rgba(37,99,235,0.12)",
                  }}
                >
                  <FontAwesomeIcon
                    icon={faArrowTrendUp}
                    style={{ fontSize: "15px", color: "#fff" }}
                  />
                </div>
                <span>Total Portfolio Value:</span>
              </div>
              <div className="gap-4 d-flex align-items-center justify-content-between">
                <div className="fs-5 fw-bold text-white">
                  £96,845.21
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Right Side - Stats */}
        <div className="col-md-8">
          <div className="row g-1 justify-content-lg-end">
            <div className="col-md-auto">
              <div className="portfolio-metric-card px-3 py-2 text-center h-100">
                <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
                  <FontAwesomeIcon icon={faChartLine} /> INVESTED
                </div>
                <div className="fw-semibold text-white text-start">
                  £88,934.12
                </div>
              </div>
            </div>
            <div className="col-md-auto">
              <div className="portfolio-metric-card px-3 py-2 text-center h-100">
                <div className="text-secondary small mb-3 d-flex align-items-center justify-content-start gap-1">
                  <FontAwesomeIcon icon={faArrowTrendUp} /> RETURN
                  <FontAwesomeIcon icon={faChevronDown} className="ms-1" />
                </div>
                <div className="fw-semibold text-success text-start">
                  £7,911.05 (8.89%)
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Performance Graph */}
      <div className="row mt-4">
        <div className="col-12">
          <div className="portfolio-metric-card p-3">
            <div className="text-secondary small mb-2">Performance</div>
            <div className="position-relative" style={{ height: '60px' }}>
              <svg width="100%" height="60" style={{ width: '100%' }}>
                {/* Main line */}
                <path
                  d="M0 50 L30 40 L60 30 L100 20"
                  stroke="#3B82F6"
                  strokeWidth="2"
                  fill="none"
                />
                {/* Dotted baseline */}
                <path
                  d="M0 45 L100 45"
                  stroke="#E5E7EB"
                  strokeWidth="1"
                  strokeDasharray="3,3"
                />
                {/* Y-axis labels */}
                <text x="85%" y="15" style={{ fontSize: '10px', fill: '#9CA3AF' }}>94,862</text>
                <text x="85%" y="30" style={{ fontSize: '10px', fill: '#9CA3AF' }}>92,384</text>
                <text x="85%" y="45" style={{ fontSize: '10px', fill: '#9CA3AF' }}>89,906</text>
              </svg>
            </div>
          </div>
        </div>
      </div>
      
      {/* Fund Cards */}
      <div className="row mt-4 g-3">
        {portfolioData.funds.map((fund) => (
          <div key={fund.id} className="col-12">
            <div className="portfolio-metric-card p-3 position-relative">
              <div className="row align-items-center">
                {/* Left - Circular Progress */}
                <div className="col-auto">
                  <div className="position-relative">
                    <div 
                      className="rounded-circle d-flex align-items-center justify-content-center"
                      style={{
                        width: '50px',
                        height: '50px',
                        background: 'conic-gradient(from 0deg, #3B82F6 0deg, #8B5CF6 90deg, #F59E0B 180deg, #10B981 270deg, #EF4444 360deg)'
                      }}
                    >
                      <div 
                        className="rounded-circle d-flex align-items-center justify-content-center"
                        style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: '#FFFFFF'
                        }}
                      >
                        <FontAwesomeIcon 
                          icon={fund.icon} 
                          style={{ fontSize: '16px', color: fund.iconColor }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                
                {/* Middle - Fund Info */}
                <div className="col">
                  <div className="fw-semibold text-white mb-1">{fund.name}</div>
                  <div className="d-flex align-items-center">
                    <FontAwesomeIcon 
                      icon={faCalendarAlt} 
                      className="text-secondary me-1"
                      style={{ fontSize: '12px' }}
                    />
                    <span style={{ color: fund.statusColor, fontSize: '12px', fontWeight: '500' }}>
                      {fund.status}
                    </span>
                  </div>
                </div>
                
                {/* Right - Financial Details */}
                <div className="col-auto text-end">
                  <div className="fw-semibold text-white mb-1">£{fund.currentValue.toLocaleString()}</div>
                  <div style={{
                    color: fund.gain >= 0 ? "#10B981" : "#EF4444",
                    fontSize: '12px',
                    fontWeight: '500'
                  }}>
                    {fund.gain >= 0 ? '+' : ''}£{fund.gain.toLocaleString()} ({fund.gainPercentage}%)
                  </div>
                </div>
              </div>
              
              {/* Progress Bar */}
              <div className="position-absolute bottom-0 start-0 end-0" style={{ height: '3px' }}>
                <div 
                  className="h-100"
                  style={{
                    width: `${fund.progress}%`,
                    backgroundColor: '#3B82F6',
                    borderBottomLeftRadius: '12px'
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoinsPortfolio; 